import { Facebook, Mail, MapPin, Phone, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import {
  CONTACT_ADDRESS_LINES,
  CONTACT_EMAIL,
  CONTACT_PHONE,
  CONTACT_PHONE_TEL,
  CONTACT_SOCIAL,
} from "@/data/siteContact";

const socials = [
  {
    name: "Facebook",
    icon: <Facebook className="h-5 w-5" />,
    href: CONTACT_SOCIAL.facebook,
  },
  {
    name: "YouTube",
    icon: <Youtube className="h-5 w-5" />,
    href: CONTACT_SOCIAL.youtube,
  },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white border-t border-gray-800 pt-12 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <Logo className="h-8 w-auto mb-4" />
            <h2 className="text-xl font-bold text-white mb-2">Skutopia Academy</h2>
            <p className="text-sm text-gray-400 mb-6 max-w-sm">
              Skutopia helps African secondary students learn, discover opportunities, and build the
              skills and evidence to pursue them.
            </p>
            <div className="flex space-x-4">
              {socials.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:text-skutopia-400 transition-colors shadow-sm hover:shadow-md"
                >
                  <span className="sr-only">{social.name}</span>
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="text-center md:text-left">
            <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-wide">
              Contact
            </h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start justify-center md:justify-start gap-2.5">
                <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-skutopia-400" aria-hidden />
                <address className="not-italic leading-relaxed">
                  {CONTACT_ADDRESS_LINES.map((line) => (
                    <span key={line} className="block">
                      {line}
                    </span>
                  ))}
                </address>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2.5">
                <Mail className="h-4 w-4 shrink-0 text-skutopia-400" aria-hidden />
                <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-skutopia-400 transition-colors">
                  {CONTACT_EMAIL}
                </a>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2.5">
                <Phone className="h-4 w-4 shrink-0 text-skutopia-400" aria-hidden />
                <a href={`tel:${CONTACT_PHONE_TEL}`} className="hover:text-skutopia-400 transition-colors">
                  {CONTACT_PHONE}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/scholars"
            className="text-xs text-gray-400 hover:text-skutopia-400 transition-colors"
          >
            Scholars Program
          </Link>
          <Link
            to="/contact"
            className="text-xs text-gray-400 hover:text-skutopia-400 transition-colors"
          >
            Contact
          </Link>
          <Link
            to="/privacy-policy"
            className="text-xs text-gray-400 hover:text-skutopia-400 transition-colors"
          >
            Privacy Policy
          </Link>
          <p className="text-xs text-center text-gray-500 font-medium">
            Copyright &copy; {year} Skutopia Academy
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
